<template>
  <company-mobile-taken-list
    :loading="loading"
    :groups="groups"
    :title="$t('t_o')"
    :search="search"
  ></company-mobile-taken-list>
</template>

<script>
import CompanyReportTabTakenMeals from "@/components/company/reports/companyTabs/companyReportTabTakenMeals.vue";
import { SHIFTS } from "@/constants/shifts";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import { percentOf } from "@/components/report/shared/takenMath";
import CompanyMobileTakenList from "../CompanyMobileTakenList.vue";
import { hasPeriodRefetch } from "../../hasPeriodRefetch";

/**
 * Mobilni "Preuzeti obroci" firme: obroci izabranih firmi sa brojem preuzetih / poručenih i po smeni. Smene,
 * firme i period su u zaglavlju. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyMobileTakenMeals",
  extends: CompanyReportTabTakenMeals,
  mixins: [hasBarShifts, hasShiftSubtitle, hasPeriodRefetch("fetchMeals")],
  components: { CompanyMobileTakenList },
  computed: {
    /** Jedna grupa bez naziva: obroci po abecedi (smene bez narudžbi se ne prikazuju). */
    groups() {
      const found = this.search
        ? this.customSearch(this.filteredMeals, [{ value: "name" }], this.search)
        : this.filteredMeals;
      const meals = found
        .filter((meal) => meal.total > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((meal, index) => ({
          key: `${meal.id || meal.name}-${index}`,
          name: meal.name,
          total: meal.total,
          taken: meal.total_payed || 0,
          complete: meal.total > 0 && meal.total_payed >= meal.total,
          shifts: SHIFTS.map((shift) => ({
            id: shift.id,
            orders: meal[`shift${shift.id}`]?.quantity || 0,
            taken: meal[`shift${shift.id}`]?.quantity_payed || 0,
          })).filter((shift) => shift.orders > 0),
        }));
      if (!meals.length) {
        return [];
      }
      const ordered = meals.reduce((sum, meal) => sum + meal.total, 0);
      const taken = meals.reduce((sum, meal) => sum + meal.taken, 0);
      return [{ key: "all", name: "", ordered, taken, complete: ordered > 0 && taken >= ordered, percent: percentOf(taken, ordered), meals }];
    },
  },
};
</script>
